import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppPropertyBasicModel, HxOrganizationService, OrganizationModel } from 'hx-services';
import { ActivatedRoute, Data, RouterLink } from '@angular/router';
import { Subject } from 'rxjs';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { HxBreadcrumbsComponent } from '@adm-web-app/components/breadcrumbs/breadcrumbs.component';
import { NzPageHeaderComponent, NzPageHeaderExtraDirective, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzButtonComponent, NzButtonGroupComponent } from 'ng-zorro-antd/button';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { JsonPipe, NgFor, NgIf } from '@angular/common';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';
import { NzPopconfirmDirective } from 'ng-zorro-antd/popconfirm';

@Component({
    selector: 'hc-organization-properties-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.less'],
  imports: [NzAffixComponent, HxBreadcrumbsComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzPageHeaderExtraDirective, NzButtonComponent, RouterLink, NzIconDirective, TranslocoDirective, NzTableComponent, NzTheadComponent, NzTrDirective, NzTableCellDirective, NzThMeasureDirective, NzTbodyComponent, NgFor, NgIf, NzButtonGroupComponent, NzWaveDirective, NzPopconfirmDirective, JsonPipe, TranslocoPipe]
})
export class OrganizationPropertyListComponent implements OnInit, OnDestroy {
  org!: OrganizationModel;
  isLoading = {
    properties: false
  };
  properties: AppPropertyBasicModel[] = [];

  private $destroyed = new Subject<void>();

  constructor(
    private aRoute: ActivatedRoute,
    private orgService: HxOrganizationService,
  ) {
  }

  ngOnInit() {
    const routeData: Data = this.aRoute.snapshot.data;
    this.org = routeData['organization'] as OrganizationModel;
    this.loadProperties();
  }

  remove(id: number): void {
    this.orgService.removeProperty(this.org.id, id).then(() => this.loadProperties());
  }

  ngOnDestroy(): void {
    this.$destroyed.next();
    this.$destroyed.complete();
  }

  private async loadProperties() {
    this.isLoading.properties = true;
    try {
      this.properties = await this.orgService.getPropertiesById(this.org.id);
    } finally {
      this.isLoading.properties = false;
    }
  }
}
